import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({ providedIn: 'root' })
export class Form4562Service {

  constructor(private http: HttpClient) {}

  loadFormData(baseUrl: string, rowData: any): Observable<any> {
    const jcd_key = rowData?.JCD_KEY ?? 250;
    const params: any = {
      action_id: 598,
      tax_year: rowData?.TAX_YEAR,
      scenario: rowData?.SCENARIO,
      jcd_key,
      combination_key: rowData?.COMBINATION_KEY
    };
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, String(params[key]));
      }
    });
    const url = `${baseUrl}/loadPivotFormJson?${urlEncoded.toString()}`;
    return this.http.get<any>(url, { withCredentials: true });
  }

  save4562Form(
    baseUrl: string,
    data: any,
    rowData: any,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=70l3gn`;
    const jcd_key = rowData?.JCD_KEY ?? 250;
    const jsonSettings = { tax_year: rowData?.TAX_YEAR, scenario: rowData?.SCENARIO, jcd_key };
    const gsParams = globalService?.globalParams ?? globalService ?? {};
    let params: any = _.merge({}, gsParams, filterParams);
    params = _.extend({ jsonObj: JSON.stringify(data) }, params);
    params = _.extend({ jsonSettings: JSON.stringify(jsonSettings) }, params);
    params.process_name = params.process_name || 'Form 4562 Save';

    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }
}
